var ItemCustomizationHelper = /** @class */ (function () {
    function ItemCustomizationHelper() {
    }
    ItemCustomizationHelper.getOptionHelperMessages = function (max_selectable, min_selectable, options, t) {
        var message = t('common.selectAsMany');
        if (min_selectable === max_selectable && max_selectable > 0) {
            message = t('common.selectMaxSelectable', {
                maxSelectable: max_selectable
            });
        }
        else if (min_selectable < max_selectable) {
            if (min_selectable === 0) {
                message = t('common.selectUpto', {
                    uptoOptions: Math.min(max_selectable, options.length)
                });
            }
            else if (min_selectable > 0) {
                message = t('common.selectOptionRange', {
                    minSelectable: min_selectable,
                    maxSelectable: max_selectable
                });
            }
        }
        var isOptionRequired = ItemCustomizationHelper.getIsOptionRequired(min_selectable, max_selectable);
        var typeOfOption = isOptionRequired
            ? t('itemCustomization.required')
            : t('itemCustomization.optional');
        return {
            message: message,
            typeOfOption: typeOfOption
        };
    };
    ItemCustomizationHelper.getIsOptionRequired = function (min_selectable) {
        return min_selectable > 0;
    };
    ItemCustomizationHelper.isRadioButton = function (min_selectable, max_selectable) {
        var isOptionRequired = false;
        if (min_selectable === max_selectable && max_selectable === 1) {
            isOptionRequired = true;
        }
        return isOptionRequired;
    };
    return ItemCustomizationHelper;
}());

export { ItemCustomizationHelper as default };
//# sourceMappingURL=helpers.js.map
